import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { ProductEventTrackingService } from 'wflow-features/product-analytics';
import { SmartlookEventService } from 'wflow-main-app/src/app/core/services/analytics/analytic-event.service';
import { IntercomService } from 'wflow-main-app/src/app/shared/components/intercom-button/intercom.service';
import { IconsModule } from 'wflow-ui';

@Component({
  imports: [CommonModule, IconsModule],
  selector: 'intercom-button',
  template: `
    <ng-container #container></ng-container>

    <ng-template #btnTpl>
      <button
        class="intercom"
        role="main"
        aria-live="polite"
        (click)="onClick()"
      >
        <wf-icon iconName="pipedrive"></wf-icon>
      </button>
    </ng-template>
  `,
  styleUrls: ['./intercom-button.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IntercomButtonComponent implements AfterViewInit {
  @ViewChild('container', { static: true, read: ViewContainerRef })
  readonly container: ViewContainerRef;
  @ViewChild('btnTpl', { static: true, read: TemplateRef })
  readonly btnTpl: TemplateRef<unknown>;

  private readonly productTrackingSvc = inject(ProductEventTrackingService);

  constructor(
    private intercomSvc: IntercomService,
    private cd: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    this.initIntercomButton(this.intercomSvc.showIntercom);
  }

  onClick() {
    SmartlookEventService.track('Intercom icon click');

    // Area S [Frustration] — self-service ran out and the user escalated to a
    // human. The Intercom launcher is this app's only support-contact control.
    this.productTrackingSvc.track('core_support_contact_initiated');

    this.intercomSvc.show();
  }

  private initIntercomButton(show: boolean) {
    if (!show) {
      return;
    }

    this.container.clear();
    this.container.createEmbeddedView(this.btnTpl);
    this.cd.detectChanges();
  }
}
